import { uploadingFilesStorage } from '$logic/persist-uploads/storage'

const blobToArrayBuffer = (blob: Blob) =>
  new Promise<ArrayBuffer>((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = e => {
      resolve(e.target.result as ArrayBuffer)
    }
    fileReader.addEventListener('error', reject)
    fileReader.readAsArrayBuffer(blob)
  })

export async function getUploadingFile(id?: string) {
  if (!id) return null
  const file = await uploadingFilesStorage.get(id)
  if (!file) return null
  return new File([file.arrayBuffer], file.name, { type: file.type })
}

export async function saveUploadingFile(id: string, file: File) {
  const arrayBuffer = await blobToArrayBuffer(file)
  const { type, name } = file
  await uploadingFilesStorage.insert({ id, name, type, arrayBuffer })
}

export async function deleteUploadingFile(id: string) {
  await uploadingFilesStorage.delete(id)
}
